// App branding and metadata
export const APP_TITLE = import.meta.env.VITE_APP_TITLE || 'Atlas Viewer';
export const APP_DESCRIPTION =
  import.meta.env.VITE_APP_DESCRIPTION ||
  'Atlas Viewer - A web-based geospatial data visualization tool';

// Custom map style defaults
export const ATLAS_DARK_STYLE_ID = 'atlas_dark';
export const ATLAS_DARK_STYLE_LABEL = 'Atlas Dark';
export const ATLAS_DARK_STYLE_DEFAULT_URL = import.meta.env.VITE_MAPBOX_STYLE_URL || '';
export const ATLAS_DARK_STYLE_ICON = '/assets/integral-analytics-logo.png';

// Fallback style configuration
export const FALLBACK_STYLE_ID = 'dark-matter';
export const FALLBACK_STYLE_LABEL = 'Dark Matter';
export const FALLBACK_STYLE_URL =
  'https://basemaps.cartocdn.com/gl/dark-matter-gl-style/style.json';
// Default map view settings
export const DEFAULT_MAP_LATITUDE = 39.1031;
export const DEFAULT_MAP_LONGITUDE = -84.512;
export const DEFAULT_MAP_ZOOM = 10;

// Documentation URLs
const DOCS_BASE_URL = import.meta.env.VITE_DOCS_URL || '/docs/';
export const DOCS_RELEASE_NOTES_URL = `${DOCS_BASE_URL.replace(/\/$/, '')}/reference/release-notes`;

// SPDX-License-Identifier: MIT
// Copyright contributors to the kepler.gl project

// Supported file extensions for data loading
export const DEFAULT_FILE_EXTENSIONS = [
  'csv',
  'tsv',
  'txt',
  'geojson',
  'json',
  'topojson',
  'parquet',
  'pq',
  'arrow',
  'feather',
  'ipc',
  'kml',
  'kmz',
  'shp',
  'shx',
  'dbf',
  'prj',
  'cpg',
];

// SPDX-License-Identifier: MIT
// Copyright contributors to the kepler.gl project

/* different option share same query type e.g. events,
and segments both use queryRunner */
import keyMirror from 'keymirror';

export const QUERY_TYPES = keyMirror({
  file: null,
  sample: null,
});

export const QUERY_OPTIONS = keyMirror({
  csv: null,
  geojson: null,
});

export const LOADING_METHODS = keyMirror({
  remote: null,
  sample: null,
});

export const LOADING_SAMPLE_LIST_ERROR_MESSAGE = 'Not able to load sample gallery';
export const LOADING_SAMPLE_ERROR_MESSAGE = 'Not able to load sample';
export const CORS_LINK = 'https://developer.mozilla.org/en-US/docs/Web/HTTP/CORS';

export const DEFAULT_FEATURE_FLAGS = {
  cloudStorage: true,
};

export const CLOUD_PROVIDERS_CONFIGURATION = {
  MAPBOX_TOKEN: import.meta.env.VITE_MAPBOX_TOKEN,
};
